import { render } from "./LinkInstallationIssueNoAction.vue?vue&type=template&id=b2e25620&scoped=true"
import script from "./LinkInstallationIssueNoAction.vue?vue&type=script&lang=js"
export * from "./LinkInstallationIssueNoAction.vue?vue&type=script&lang=js"

import "./LinkInstallationIssueNoAction.vue?vue&type=style&index=0&id=b2e25620&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e25620"]])

export default __exports__